import LocationAdapter from '@javascripts/adapters/location_adapter';
import { sendAutoplayEvent } from '@javascripts/service/next_video/tracker';

export default class Countdown {
  constructor(options = {}){
    this._player = options.player;
    this._element = options.element;
    this._nextUrl = options.nextUrl;
    this._nextVideoId = options.nextVideoId;
    this._currentCountdown = this.initialCountdown();
    this._countdownInterval = null;
    this._adPlaying = false;
  }

  initialCountdown(){
    return 5;
  }

  player() {
    return this._player;
  }

  element() {
    return this._element;
  }

  nextUrl() {
    return this._nextUrl;
  }

  nextVideoId() {
    return this._nextVideoId;
  }

  init() {
    this.updateElementText();

    this.player().on('next_video_show', this.onNextVideoShow.bind(this));

    this.player().on("dispose", this.clearCountdownInterval.bind(this));

    this.player().on("adstarted", this.setAdPlaying.bind(this));
    this.player().on("adend", this.unsetAdPlaying.bind(this));
    this.player().on("adskipped", this.unsetAdPlaying.bind(this));
    this.player().on("adserror", this.unsetAdPlaying.bind(this));
  }

  countdownText(){
    return `Next in ${this._currentCountdown}`;
  }

  updateElementText(){
    this.element().innerText = this.countdownText();
  }

  onNextVideoShow(){
    this._currentCountdown = this.initialCountdown();
    this.updateElementText();

    this.createCountdownInterval();
  }

  createCountdownInterval(){
    if(this._countdownInterval == null){
      this._countdownInterval = window.setInterval(this.onOneSecondElapsed.bind(this), 1000);
    }
  }

  clearCountdownInterval(){
    window.clearInterval(this._countdownInterval);
    this._countdownInterval = null;
  }

  onOneSecondElapsed(){
    if(this._adPlaying) return;

    this._currentCountdown -= 1;
    this.updateElementText();

    if(this._currentCountdown == 0){
      this.clearCountdownInterval();
      this.goToNextVideo();
    }
  }

  goToNextVideo(){
    sendAutoplayEvent(this.nextVideoId());
    LocationAdapter.href(this.nextUrl());
  }

  setAdPlaying(){
    this._adPlaying = true;
  }

  unsetAdPlaying(){
    this._adPlaying = false;
  }
}
